
/* injects from baggage-loader */

'use strict';

import lockUnlockFiltersDirective from './lockUnlockFilters.directive';
import lockUnlockFiltersConstant from './lockUnlockFilters.constant';

/**
 * Campaign Select module definition.
 */
const lockUnlockFiltersModule = angular.module('lockUnlockFilters.module', []);

lockUnlockFiltersModule.directive('lockUnlockFilters', lockUnlockFiltersDirective);
lockUnlockFiltersModule.constant('lockUnlockFiltersConstant', lockUnlockFiltersConstant);

export default lockUnlockFiltersModule;



// WEBPACK FOOTER //
// ./src/app/core/components/lockUnlockFilters/lockUnlockFilters.module.js